// extracted by mini-css-extract-plugin
export default {"divider":"sNjtt","divider_view_accent":"ryjoe","divider_view_default":"sZRlv","divider__label":"s2IUq","divider__label_view_accent":"ZDV5C"};